import React from 'react'
import NumberFormat from 'react-number-format'
import { bottom } from '@popperjs/core'

const splitPrice = (price) => {
    if (price==null || price==='') return [null];
    const idx = price.indexOf(' - ');
    if (idx < 0) return (
        <NumberFormat 
            displayType='text'
            decimalScale={2}
            fixedDecimalScale={true} 
            thousandSeparator={true}
            prefix='$'
            value={price}
        />
    )
    return <>
        <NumberFormat
            displayType='text'
            decimalScale={2}
            fixedDecimalScale={true} 
            thousandSeparator={true}
            prefix='$'
            value={price.slice(0, idx)}
        />
        -
        <NumberFormat
            displayType='text'
            decimalScale={2}
            fixedDecimalScale={true} 
            thousandSeparator={true}
            prefix='$'
            value={price.slice(idx+3)}
        />
    </>
}

export default function StoneCard({stone, deleteStone, weight, quantity, onChange}) {
    return (
        <div className='confirmation-container border stone-card confirmation-text'>
            <div className='stone-card-inner'>
                <div className='row even-split' style={{marginBottom: '0.5rem', color: 'var(--primary-colour)'}}>
                    <div className='align-top bold'>
                        <i className={`fa${stone.virtual ? 'r' : 's'} fa-gem`} />&nbsp;
                        {stone.parcelName} &mdash; {stone.skuDescription}
                    </div>
                    <div className='right align-top semibold'>
                        {
                            stone.virtual
                            ? splitPrice(stone.total)
                            : <NumberFormat 
                                displayType='text'
                                decimalScale={2}
                                fixedDecimalScale={true} 
                                thousandSeparator={true}
                                prefix='$'
                                value={stone.total}
                            />
                        }
                    </div>
                </div>
                <div className='row even-split'>
                    <div className='caption40'>
                        <div className='align-top semibold'>Shape:</div>
                        <div className='align-top'>{stone.shapeCodes}</div>
                    </div>
                    <div className='caption40'>
                        <div className='align-top semibold'>Colour:</div>
                        <div className='align-top'>{stone.colourText}</div>
                    </div>
                </div>
                <div className='row even-split'>
                    <div className='caption40'>
                        <div className='align-top semibold'>Stone Weight:</div>
                        <div className='align-top'>{stone.weightText}</div>
                    </div>
                    <div className='caption40'>
                        <div className='align-top semibold'>Clarity:</div>
                        <div className='align-top'>{stone.clarityText}</div>
                    </div>
                </div>
                <div className='row even-split'>
                    <div className='caption40'>
                        <div className='align-top semibold'>Confirm Weight:</div>
                        <div className='align-top'><NumberFormat name='weight' displayType='input' decimalScale={2} value={weight} onChange={onChange} className='melee-confirm-input'/></div>
                    </div>
                    <div className='caption40'>
                        <div className='align-top semibold'>Confirm Quantity:</div>
                        <div className='align-top'><NumberFormat name='quantity' displayType='input' decimalScale={0} value={quantity} onChange={onChange} className='melee-confirm-input'/></div>
                    </div>
                </div>
            </div>
            <div className='stone-card-remove-button'>
                {
                    deleteStone
                    ? <button className='tab-button right' onClick={() => deleteStone(stone.parcelName)}><i className='fas fa-times-circle'/></button>
                    : null
                }
            </div>
        </div>
    )
}